/*  Shared  */
import Helpers from 'application/Shared/Helpers/Functions';

/*  Constants  */
const { isset } = Helpers;

class Env {
    constructor() {
        this.env = process.env;
    }

    get = (key) => {
        if (!isset(this.env, key)) {
            return '';
        }
        return this.env[key];
    };

    getEnv = () => {
        const name = this.get('REACT_APP_NODE_ENV');

        switch (name) {
            case 'local':
                return 'local';
            case 'development':
                return 'dev';
            case 'stage':
                return 'stage';
            case 'demo':
                return 'demo';
            case 'production':
                return 'prod';
            default:
                return name;
        }
    };

    isLocal = () => this.getEnv() === 'local';

    isDev = () => this.getEnv() === 'dev';

    isStage = () => this.getEnv() === 'stage';

    isDemo = () => this.getEnv() === 'demo';

    isProd = () => this.getEnv() === 'prod';

    describe = () => {
        // Using console.log here instead of debug to get rid of circular dependency when importing debug.
        /* eslint-disable no-console */
        console.log('ENV', this.getEnv(), this.get('REACT_APP_PRODUCTION_URL'));
        console.log(
            'ENV (REACT_APP_OKTA_ISSUER)',
            this.get('REACT_APP_OKTA_ISSUER')
        );
        console.log(
            'ENV (REACT_APP_OKTA_AUTHORIZE_URL)',
            this.get('REACT_APP_OKTA_AUTHORIZE_URL')
        );
        console.log(
            'ENV (REACT_APP_OKTA_CLIENT_ID)',
            this.get('REACT_APP_OKTA_CLIENT_ID')
        );
    };
}

export default Env;
